import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Deities.css";
import "./DeitiesMedia.css"

export const Deities = () => {
  const [activeIndex, setActiveIndex] = useState(0);
    const [canScroll, setCanScroll] = useState(false);
  const content = useSelector((state) => state.gallery?.introSection); 
  const intro = content
  const deityList = content?.mainDeities || [];
  const mainDeitiesTitle = content?.mainDeitiesTitle || "MAIN DEITIES";

  useEffect(() => {
  AOS.init({ duration: 1000 ,once:true});
  let isThrottled = false;
  const handleWheel = (e) => {
    if (isThrottled) return;
    if (e.deltaY > 0 && activeIndex < deityList.length - 1) {
      setActiveIndex((prev) => prev + 1);
    } else if (e.deltaY < 0 && activeIndex > 0) {
      setActiveIndex((prev) => prev - 1);
    }
    isThrottled = true;
    setTimeout(() => {
      isThrottled = false;
    }, 1000);
  };

  let startY = 0;
  const handleTouchStart = (e) => {
    startY = e.touches[0].clientY;
  };
  const handleTouchEnd = (e) => {
    const endY = e.changedTouches[0].clientY;
    const deltaY = startY - endY;

    if (Math.abs(deltaY) > 50 && !isThrottled) {
      if (deltaY > 0 && activeIndex < deityList.length - 1) {
        setActiveIndex((prev) => prev + 1);
      } else if (deltaY < 0 && activeIndex > 0) {
        setActiveIndex((prev) => prev - 1);
      }

      isThrottled = true;
      setTimeout(() => {
        isThrottled = false;
      }, 1000);
    }
  };

  window.addEventListener("wheel", handleWheel);
  window.addEventListener("touchstart", handleTouchStart);
  window.addEventListener("touchend", handleTouchEnd);
  return () => {
    window.removeEventListener("wheel", handleWheel);
    window.removeEventListener("touchstart", handleTouchStart);
    window.removeEventListener("touchend", handleTouchEnd);
  };
  }, [activeIndex, deityList.length]);
  
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);


  return (
    <div className="deities-main">
      {intro && (
        <div className="deities-section-page">
          <div className="deities-images">
            <div className="left-image">
              <img src={intro.images[0]} alt="Deity 1" />
            </div>
            <div className="right-images">
              <img src={intro.images[1]} alt="Deity 2" />
              <img src={intro.images[2]} alt="Deity 3" />
            </div>
          </div>
          <div className="deities-content">
            <h1>
              <span>{intro.heading.split(" ")[0]}</span>{" "}
              {intro.heading.split(" ").slice(1).join(" ")}
            </h1>
            {intro.paragraphs.map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>
        </div>
      )}
      <div className="main-deities-section">
        <h1>{mainDeitiesTitle}</h1>
        <div className="deities-scroll-wrapper">
          {deityList.map((deity, index) => (
            <div
              className={`fullscreen-section ${
                index === activeIndex ? "active" : ""
              }`}
              key={index}
            >
              <div className="deity-text" data-aos="fade-right">
                <h2>{deity.name}</h2>
                <p>{deity.description?.en}</p>
              </div>
              <div className="deity-image" data-aos="fade-left">
                <img src={deity.image} alt={deity.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
